export default "__VITE_ASSET__CkC8q3iL__"